import { cyan_300, gray_300, gray_400, gray_700, green_500, indigo_600, lime_400, magenta_600, orange_400, pink_500, purple_500, red_500, sky_500, teal_400, yellow_300 } from './color.js';
export const categorical_set_1_1 = sky_500;
export const categorical_set_1_2 = orange_400;
export const categorical_set_1_3 = teal_400;
export const categorical_set_1_4 = purple_500;
export const categorical_set_1_5 = yellow_300;
export const categorical_set_1_6 = magenta_600;
export const categorical_set_1_7 = cyan_300;
export const categorical_set_1_8 = green_500;
export const categorical_set_1_9 = pink_500;
export const categorical_set_1_10 = indigo_600;
export const categorical_set_1_11 = lime_400;
export const categorical_set_1_12 = red_500;
export const categorical_set_2_1 = teal_400;
export const categorical_set_2_2 = orange_400;
export const categorical_set_2_3 = purple_500;
export const categorical_set_2_4 = magenta_600;
export const categorical_set_2_5 = indigo_600;
export const categorical_set_2_6 = yellow_300;
export const categorical_set_2_7 = green_500;
export const categorical_set_2_8 = cyan_300;
export const categorical_set_2_9 = pink_500;
export const categorical_set_2_10 = lime_400;
export const categorical_set_2_11 = red_500;
export const categorical_set_2_12 = sky_500;
export const sky_red_100 = '#4E0E0E';
export const sky_red_200 = '#731A19';
export const sky_red_300 = '#9A2E2B';
export const sky_red_400 = '#CE4844';
export const sky_red_500 = '#E76057';
export const sky_red_600 = '#ED8876';
export const sky_red_700 = '#F4AD91';
export const sky_red_800 = '#FAD4AF';
export const sky_red_900 = '#FFF4C7';
export const sky_red_1000 = '#C8DACD';
export const sky_red_1100 = '#94C1D2';
export const sky_red_1200 = '#5EA7D7';
export const sky_red_1300 = '#1E88DD';
export const sky_red_1400 = '#0F72C6';
export const sky_red_1500 = '#0B5193';
export const sky_red_1600 = '#083A6E';
export const sky_red_1700 = '#06254D';
export const sky_red_1800 = '#1A1A1A';
export const indigo_magenta_100 = '#580C2E';
export const indigo_magenta_200 = '#74113E';
export const indigo_magenta_300 = '#9D2359';
export const indigo_magenta_400 = '#C23571';
export const indigo_magenta_500 = '#D74781';
export const indigo_magenta_600 = '#E47F99';
export const indigo_magenta_700 = '#ECA2AB';
export const indigo_magenta_800 = '#F2CED1';
export const indigo_magenta_900 = '#F4E5E6';
export const indigo_magenta_1000 = '#D3CEE2';
export const indigo_magenta_1100 = '#A6ADDE';
export const indigo_magenta_1200 = '#7D8BE6';
export const indigo_magenta_1300 = '#5A6ADD';
export const indigo_magenta_1400 = '#3F53D1';
export const indigo_magenta_1500 = '#2D3EAB';
export const indigo_magenta_1600 = '#1C2B87';
export const indigo_magenta_1700 = '#0F1C6B';
export const indigo_magenta_1800 = '#1A1A1A';
export const teal_orange_100 = '#563004';
export const teal_orange_200 = '#6F3E07';
export const teal_orange_300 = '#8E500A';
export const teal_orange_400 = '#AD620D';
export const teal_orange_500 = '#CA7310';
export const teal_orange_600 = '#D9933C';
export const teal_orange_700 = '#E6B56D';
export const teal_orange_800 = '#F3D59B';
export const teal_orange_900 = '#FFF4C7';
export const teal_orange_1000 = '#CCE1BB';
export const teal_orange_1100 = '#96CCAE';
export const teal_orange_1200 = '#5EB7A0';
export const teal_orange_1300 = '#279D8D';
export const teal_orange_1400 = '#1F8375';
export const teal_orange_1500 = '#17665C';
export const teal_orange_1600 = '#0E4941';
export const teal_orange_1700 = '#07342D';
export const teal_orange_1800 = '#1A1A1A';
export const purple_teal_100 = '#07342D';
export const purple_teal_200 = '#0E4941';
export const purple_teal_300 = '#17665C';
export const purple_teal_400 = '#1F8375';
export const purple_teal_500 = '#279D8D';
export const purple_teal_600 = '#5EB7A0';
export const purple_teal_700 = '#96CCAE';
export const purple_teal_800 = '#CCE1BB';
export const purple_teal_900 = '#FFF4C7';
export const purple_teal_1000 = '#E1CCC8';
export const purple_teal_1100 = '#BE9DC8';
export const purple_teal_1200 = '#A277C8';
export const purple_teal_1300 = '#844EC8';
export const purple_teal_1400 = '#6A34B5';
export const purple_teal_1500 = '#562797';
export const purple_teal_1600 = '#441B7C';
export const purple_teal_1700 = '#2F0D5D';
export const purple_teal_1800 = '#1A1A1A';
export const red_yellow_100 = '#FFF4C7';
export const red_yellow_200 = '#FFEB99';
export const red_yellow_300 = '#FFDC52';
export const red_yellow_400 = '#FFC73F';
export const red_yellow_500 = '#FFA722';
export const red_yellow_600 = '#FF8D0A';
export const red_yellow_700 = '#F77619';
export const red_yellow_800 = '#EC5A2C';
export const red_yellow_900 = '#E13D3D';
export const red_yellow_1000 = '#CD3636';
export const red_yellow_1100 = '#B22D2D';
export const red_yellow_1200 = '#9D2424';
export const red_yellow_1300 = '#891A1A';
export const red_yellow_1400 = '#6E1414';
export const red_yellow_1500 = '#530909';
export const red_yellow_1600 = '#320606';
export const purple_magenta_100 = '#FFF4C7';
export const purple_magenta_200 = '#F9D1BF';
export const purple_magenta_300 = '#F3A5AF';
export const purple_magenta_400 = '#ED82A3';
export const purple_magenta_500 = '#E75D96';
export const purple_magenta_600 = '#E3458D';
export const purple_magenta_700 = '#C83E90';
export const purple_magenta_800 = '#AF3892';
export const purple_magenta_900 = '#953194';
export const purple_magenta_1000 = '#7E2B96';
export const purple_magenta_1100 = '#642498';
export const purple_magenta_1200 = '#521F99';
export const purple_magenta_1300 = '#42187E';
export const purple_magenta_1400 = '#37136C';
export const purple_magenta_1500 = '#2B0C56';
export const purple_magenta_1600 = '#1E0642';
export const sky_teal_100 = '#FFF4C7';
export const sky_teal_200 = '#CFEBC4';
export const sky_teal_300 = '#AAE4C1';
export const sky_teal_400 = '#8DDEBF';
export const sky_teal_500 = '#66D6BC';
export const sky_teal_600 = '#33CCB8';
export const sky_teal_700 = '#30BDBA';
export const sky_teal_800 = '#2CAABD';
export const sky_teal_900 = '#2899BF';
export const sky_teal_1000 = '#2487C1';
export const sky_teal_1100 = '#2075C3';
export const sky_teal_1200 = '#1C65C4';
export const sky_teal_1300 = '#1652A0';
export const sky_teal_1400 = '#103E7A';
export const sky_teal_1500 = '#092952';
export const sky_teal_1600 = '#031833';
export const highlight_neutral_dark = gray_700;
export const highlight_neutral_light = gray_400;
export const highlight_callout_dark = sky_500;
export const highlight_callout_light = sky_500;
export const highlight_empty_data_dark = gray_700;
export const highlight_empty_data_light = gray_300;
//# sourceMappingURL=color.data_vis.js.map